import React from 'react';
import { ShieldCheck, Users } from 'lucide-react';

const LoginFormFooter = () => {
  return (
    <div className="mt-auto flex flex-col items-center gap-3 pb-2">
      <div className="flex items-center gap-1.5 text-xs text-gray-400">
        <ShieldCheck className="h-3.5 w-3.5" />
        <span>Your data is secure and encrypted</span>
      </div>
      <div className="-mx-6 flex w-[calc(100%+3rem)] items-center justify-center gap-2 bg-gray-50 py-3 text-sm text-gray-500 sm:-mx-8 sm:w-[calc(100%+4rem)] lg:-mx-10 lg:w-[calc(100%+5rem)]">
        <Users className="h-4 w-4" />
        <span>Built by a builder, for builders.</span>
      </div>
    </div>
  );
};

export default LoginFormFooter;
